import { render, staticRenderFns } from "./aboutTechnical.vue?vue&type=template&id=bdb7441e&scoped=true&"
import script from "./aboutTechnical.vue?vue&type=script&lang=js&"
export * from "./aboutTechnical.vue?vue&type=script&lang=js&"
import style0 from "./aboutTechnical.vue?vue&type=style&index=0&id=bdb7441e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb7441e",
  null
  
)

export default component.exports